import LeftNavigationComponent from './left';

export {
    LeftNavigationComponent
};
